package com.essntl.features.category.ui.allcategories

import com.essntl.core.utils.viewmodel.State
import com.essntl.features.category.domain.model.CategoryModel

data class AllCategoriesState(
    val getAllCategories: State<List<CategoryModel>> = State(),
)
